var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { onError } from '@apollo/client/link/error';
const isServerError = (networkError) => {
    if (!networkError)
        return false;
    return 'statusCode' in networkError && 'result' in networkError;
};
export function createSplunkErrorLink(logger) {
    return onError(({ graphQLErrors, networkError, operation }) => {
        const operationName = operation.operationName;
        if (graphQLErrors) {
            graphQLErrors.forEach((_a) => {
                var { message, path } = _a, rest = __rest(_a, ["message", "path"]);
                const extensions = rest.extensions;
                const code = extensions === null || extensions === void 0 ? void 0 : extensions.code;
                const metadata = {
                    operationName,
                    path,
                    errorCode: code,
                    eventCategory: 'graphql_error',
                };
                if (code === 'BAD_REQUEST') {
                    logger.warn(`[GraphQL error]: ${message}`, metadata);
                }
                else {
                    logger.error(`[GraphQL error]: ${message}`, metadata);
                }
            });
        }
        if (networkError) {
            const metadata = {
                operationName,
                eventCategory: 'graphql_error',
            };
            if (isServerError(networkError)) {
                metadata.statusCode = networkError.statusCode;
            }
            logger.error(`[Network error]: ${networkError}`, metadata);
        }
    });
}
